import { localeRequestHeaders } from './localePreference';
import { apiErrorMessage } from './apiErrorMessages';

const API_PREFIX = '/api/v1';

async function apiRequest(path, user, options = {}) {
  const token = await user.getIdToken();
  let response;
  try {
    response = await fetch(`${API_PREFIX}${path}`, {
      ...options,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...localeRequestHeaders(),
        ...(options.headers || {}),
      },
    });
  } catch {
    throw new Error(apiErrorMessage('companyRadarNetwork'));
  }

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.detail || apiErrorMessage('companyRadarRequest'));
  }
  return response.json();
}

export function createCompanyRadarItem({ user, companyName, websiteUrl }) {
  return apiRequest('/company-radar/companies', user, {
    method: 'POST',
    body: JSON.stringify({ companyName, websiteUrl: websiteUrl || '' }),
  });
}

export function retryCompanyRadarItem({ user, radarId }) {
  return apiRequest(`/company-radar/companies/${encodeURIComponent(radarId)}/retry`, user, {
    method: 'POST',
  });
}
